<template lang="pug">
nav.wrapper
  nav.branded
    .left
      .logo
        router-link(:to='$site.Routes.Home')
          img(:src='logoPath' id='themeLogo')

      a.bars(@click='toggle' href='#')
        FontAwesomeIcon.center(:icon='$icons.bars')

    .title
      h2.with-icon {{ header.title.text }}
      FontAwesomeIcon.fixed-width(v-if='header.title.faIcon' :icon='header.title.faIcon')

    .right
      .user-info
        a.vue-avatar(href="/logout" @click.prevent="doLogout" id="avatar" :title="title")
          avatar.navbar-nav(:username="fullname", :size="size" :customStyle="style")

        div.role(v-if="currentRole")
          template(v-if='currentRole.recruitmentAgency')
            h3.type {{ componentRoleName }} role for
            h3.recruitmentAgencyName {{ currentRole.recruitmentAgency.names.display }}
          template(v-else)
            h3.type {{ componentRoleName }} role
</template>

<script>
import Avatar from "vue-avatar";
import { addClass, removeClass } from "@gemma/utils";
import "./scss";
import { logout } from "@/utils";
import { Roles, SquareName } from "@timesheets/constants-common";
import { WebApplicationConstants } from "@/setup/WebApplicationConstants";
import { Events } from "@timesheets/webapp-support";

const logoImageSelector = ".navbar-wrapper .nav  .logo img";

export default {
  name: "Navbar",
  components: {
    Avatar,
  },
  data() {
    return {
      header: this.$store.state.header,
      style: {
        "line-height": "inherit",
        "font-size": window.Breakpoints.is("xs") ? "0.75rem" : "1rem",
      },
      expanded: true,
    };
  },
  computed: {
    size() {
      return window.Breakpoints.is("xs") ? 25 : 40;
    },
    fullname() {
      return this.currentSession.account.isLoggedIn ? this.currentSession.account.fullname : "The API is unavailable";
    },
    title() {
      if (this.currentSession.account.isLoggedIn) {
        return "You are logged in as " + this.fullname + " (" + this.currentSession.account.emailAddress + ")";
      } else {
        return "The API is unavailable";
      }
    },
    componentRoleName() {
      if (this.currentRole) {
        switch (this.currentRole.type) {
          case Roles.PersonalRole.TypeName:
            return "Personal";

          case Roles.RecruitmentAgencyAdministrationRole.TypeName:
            return this.isSuperAdministrator ? "Super Admin" : "Administration";

          case Roles.AuthorisingRole.TypeName:
            return "Authorising";

          case Roles.ContractingRole.TypeName:
            return this.recruitmentAgencySettings.customisation.contractor.name.singular.initialUpper;

          default:
            return "";
          // throw new GemmaError(`Unknown roleType: ${this.currentRole.type}`, { context: { roleType: this.currentRole.type } });
        }
      } else {
        return "";
      }
    },
    logoPath() {
      const logoPath = this.expanded ? this.$store.getters.currentTenantRectangularLogoPath : this.$store.getters.currentTenantSquareLogoPath;

      return logoPath;
    },
  },
  watch: {
    expanded(newExpanded) {
      if (newExpanded) {
        removeClass(logoImageSelector, SquareName);
      } else {
        addClass(logoImageSelector, SquareName);
      }
    },
  },
  created() {
    WebApplicationConstants.listenerEventBuses.system.on(
      Events.SidebarWidthChangedEvent.Type,
      event => {
        this.expanded = event.data === this.$Events.SidebarWidthState.Expanded;
      },
      this
    );
  },
  methods: {
    toggle() {
      WebApplicationConstants.eventBus.publish(new this.$Events.NavbarToggledEvent());
    },
    async doLogout() {
      await logout(this.$app.api);
    },
  },
};
</script>
